<template>
  <BaseSelect
    v-model="currentLocale"
    ky
    valu
    shape="rounded"
    condensed
    icon="lucide:languages"
  >
    <option
      v-for="locale in availableLocales"
      :key="locale.code"
      :value="locale.code"
    >
      {{ locale.name }}
    </option>
  </BaseSelect>
</template>
<script setup>
/*
    Docs: https://i18n.nuxtjs.org/

    This works by reading the cookie (set in nuxt.config.js - i18n) and then
    setting the Nuxt locale accordingl.  It should get the inital locale from the browser
    but upon setting it manually, save it in the cookie for future use.

    The currentLocale is a reference to the i18n locale.value (current), and is watched for changes,
  after which the setLocale updates the i18n with the new locale.
*/
const
  { locale, locales, setLocale } = useI18n()
const availableLocales = locales.value
const currentLocale = ref(locale.value)

watch(currentLocale, (newLocale) => {
  setLocale(newLocale)
}, { immediate: true })
</script>
